<template>
  <div style="page-break-inside: avoid;">
  <Widgest widgestType="outer" isOpenAll :isBig="true" v-if="sigsLen > 0 || !onlyIncludeStatic">
    <template #title>{{$t('report.analyse.mitre_att.title_label')}}：<span :style="{color: $isDark() ? '#ccceda' : '#525966'}">{{$t('report.analyse.mitre_att.title_0')}} <font color="#00ab7a">{{ sigsLen }}</font> {{$t('report.analyse.mitre_att.title_1')}}</span></template>
    <div class="mitreAttck-wrap">
      <span>当前展示所有命中技术点，查看<span style="cursor: pointer;color: #00ab7a;" @click="openDrawer">全部技术点</span></span>
    </div>
    <div style="width: 100%; overflow-x: auto;">
      <table class="mitre-table">
        <tr class="mitre-table-header" v-if="sigsLen > 0 || !showAll">
          <th v-for="(v, index) in mitre" :key="index" class="mitre-th">{{ v.name }}</th>
        </tr>
        <tr class="mitre-table-row" v-for="(i, rowIndex) in mitreMaxLen" :key="rowIndex">
          <td
            :class="[
              'mitre-table-col',
              {
                'match': item.attack_list.length > rowIndex && sigs[item.attack_list[rowIndex].attackid],
                'sub-technique': item.attack_list.length > rowIndex && item.attack_list[rowIndex].attackid.includes('.'),
                'has-blue': item.attack_list.length > rowIndex && tagCalc(item.attack_list[rowIndex].attackid).blue > 0,
                'has-warning': item.attack_list.length > rowIndex && tagCalc(item.attack_list[rowIndex].attackid).warning > 0,
                'has-error': item.attack_list.length > rowIndex && tagCalc(item.attack_list[rowIndex].attackid).error > 0,
                'has-sub-technique': item.attack_list.length > rowIndex && !item.attack_list[rowIndex].attackid.includes('.') && hasSubTechnique(item, rowIndex),
                'highest-error': item.attack_list.length > rowIndex && !item.attack_list[rowIndex].attackid.includes('.') && getHighestSeverity(item.attack_list[rowIndex].attackid) === 'error',
                'highest-warning': item.attack_list.length > rowIndex && !item.attack_list[rowIndex].attackid.includes('.') && getHighestSeverity(item.attack_list[rowIndex].attackid) === 'warning',
                'highest-blue': item.attack_list.length > rowIndex && !item.attack_list[rowIndex].attackid.includes('.') && getHighestSeverity(item.attack_list[rowIndex].attackid) === 'blue',
                'sub-highest-error': item.attack_list.length > rowIndex && item.attack_list[rowIndex].attackid.includes('.') && getSubTechniqueHighestSeverity(item.attack_list[rowIndex].attackid.split('.')[0]) === 'error',
                'sub-highest-warning': item.attack_list.length > rowIndex && item.attack_list[rowIndex].attackid.includes('.') && getSubTechniqueHighestSeverity(item.attack_list[rowIndex].attackid.split('.')[0]) === 'warning',
                'sub-highest-blue': item.attack_list.length > rowIndex && item.attack_list[rowIndex].attackid.includes('.') && getSubTechniqueHighestSeverity(item.attack_list[rowIndex].attackid.split('.')[0]) === 'blue'
              }
            ]"
            v-for="(item, colIndex) in showAttckMitre"
            :key="colIndex"
            @click="attckClick(item.attack_list[rowIndex])"
          >
            <span
              v-if="item.attack_list.length > rowIndex && sigs[item.attack_list[rowIndex].attackid]"
            >
              <!-- 父技术点显示名称和 (c/t) -->
              <span v-if="!item.attack_list[rowIndex].attackid.includes('.') && hasSubTechnique(item, rowIndex)" class="name-wrapper">
                <span class="name-text">{{ item.attack_list[rowIndex].name }}</span>
                <span class="sub-technique-count">({{ getSubTechniqueCount(item.attack_list[rowIndex].attackid).c }}/{{ getSubTechniqueCount(item.attack_list[rowIndex].attackid).t }})</span>
              </span>
              <!-- 子技术点不显示 (c/t) -->
              <span v-else>
                {{ item.attack_list.length > rowIndex ? item.attack_list[rowIndex].name : '' }}
              </span>
              <div class="tagWrapper">
                <template v-for="(c, x) in tagCalc(item.attack_list[rowIndex].attackid)">
                  <span v-if="c !== 0" :key="x" :class="`flag-${x}`">{{ c }}</span>
                </template>
              </div>
            </span>
            <span v-else>
              {{ item.attack_list.length > rowIndex ? item.attack_list[rowIndex].name : '' }}
            </span>
          </td>
        </tr>
      </table>
    </div>
  </Widgest>
  </div>
</template>

<script>
// import mitre from 'utils/lib/AttckData'
// import mitreEn from 'utils/lib/AttckData.en-US.js'
import { isZh } from 'app/i18n'
import { getAttackInfo } from 'services/report'
export default {
  name: 'MitreAttck',
  components: {
  },
  props: {
    behaviorfeature: {
      type: Object
    },
    onlyIncludeStatic: {
      type: Boolean
    },
    mitre: {
      type: Array
    }
  },
  data: () => ({
    drawerVisible: false, // 控制抽屉显示
    mitreShow: false,
    showDetail: false,
    showAll: true, // 默认隐藏未命中技术点
    loading: false,
    attck: {}
    // mitre: isZh() ? mitre : mitreEn
  }),
  computed: {
    signatures() {
      return this.behaviorfeature.signatures
    },
    sigs() {
      const ret = {}
      if (this.signatures) {
        this.signatures.forEach((ele) => {
          if (ele.attackid && ele.attackid !== ' ') {
            ele.attackid.split(',').forEach((id) => {
              const trimmedId = id.trim()
              if (ret[trimmedId] === undefined) {
                ret[trimmedId] = []
              }
              // 查找技术点名称
              let techName = ''
              this.mitre.forEach(tactic => {
                const foundTech = tactic.attack_list.find(tech => tech.attackid === trimmedId)
                if (foundTech) {
                  techName = foundTech.name
                }
              })
              // 添加技术点信息
              ret[trimmedId].push({
                id: trimmedId,
                desc: isZh() ? ele.descripzhcn : ele.description,
                severity: ele.severity,
                name: techName
              })

              // 处理子技术点的父技术点
              if (trimmedId.includes('.')) {
                const parentId = trimmedId.split('.')[0]
                if (ret[parentId] === undefined) {
                  ret[parentId] = []
                }
                ret[parentId].push({
                  id: trimmedId,
                  desc: isZh() ? ele.descripzhcn : ele.description,
                  severity: ele.severity,
                  name: techName // 子技术点使用自己的名称
                })
              }
            })
          }
        })
      }
      return ret
    },
    groupedSigs() {
      if (!this.attck.attackid || !this.sigs[this.attck.attackid]) {
        return []
      }
      const groupedMap = new Map()
      this.sigs[this.attck.attackid].forEach(item => {
        const key = item.id
        if (!groupedMap.has(key)) {
          groupedMap.set(key, {
            id: item.id,
            name: item.name,
            descriptions: []
          })
        }
        groupedMap.get(key).descriptions.push({
          desc: item.desc,
          severity: item.severity
        })
      })
      const groupedItems = Array.from(groupedMap.values())
      return groupedItems.sort((a, b) => {
        const aIsSub = a.id.includes('.')
        const bIsSub = b.id.includes('.')
        if (!aIsSub && bIsSub) return -1
        if (aIsSub && !bIsSub) return 1
        return a.id.localeCompare(b.id)
      })
    },
    sigsLen() {
      const uniqueIds = new Set(Object.keys(this.sigs).filter(id => !id.includes('.')))
      Object.keys(this.sigs).forEach(id => {
        if (id.includes('.')) {
          uniqueIds.add(id)
        }
      })
      return uniqueIds.size
    },
    mitreMaxLen() {
      return this.showAttckMitre
        .map((item) => item.attack_list.length)
        .reduce((prev, cur) => Math.max(prev, cur), 0)
    },
    showAttckMitre() {
      return this.mitre.map((tactic) => {
        const attackList = [...tactic.attack_list]
        const attackMap = new Map()
        attackList.forEach((tech) => {
          let techName = tech.name
          if (tech.attackid.includes('.')) {
            techName = tech.name.includes('：') ? tech.name.split('：')[1].trim() : tech.name
          }
          attackMap.set(tech.attackid, { ...tech, name: techName })
        })

        const newAttackList = []
        const addedTechIds = new Set()

        // 收集属于当前 tactic 的命中技术点
        attackList.forEach((tech) => {
          const techId = tech.attackid
          // 如果技术点命中，添加到列表
          if (this.sigs[techId] && !addedTechIds.has(techId)) {
            newAttackList.push(attackMap.get(techId))
            addedTechIds.add(techId)
          }
        })

        // 再次遍历，处理子节点命中时添加父节点
        attackList.forEach((tech) => {
          const techId = tech.attackid
          if (techId.includes('.')) {
            const parentId = techId.split('.')[0]
            if (this.sigs[techId] && !addedTechIds.has(parentId)) {
              const parentTech = attackMap.get(parentId)
              if (parentTech) {
                newAttackList.push(parentTech)
                addedTechIds.add(parentId)
              }
            }
          }
        })

        // 在当前 tactic 内部按 attackid 排序，确保父节点在上，子节点在下
        newAttackList.sort((a, b) => a.attackid.localeCompare(b.attackid))

        return {
          ...tactic,
          attack_list: newAttackList
        }
      })
    }
  },
  methods: {
    openDrawer() {
      this.drawerVisible = true
    },
    hasSubTechnique(item, rowIndex) {
      if (rowIndex + 1 >= item.attack_list.length) return false
      const currentTechId = item.attack_list[rowIndex].attackid
      const nextTechId = item.attack_list[rowIndex + 1].attackid
      return !currentTechId.includes('.') && nextTechId.includes('.') && nextTechId.startsWith(currentTechId + '.')
    },
    getSubTechniqueCount(parentId) {
      const subTechniqueIds = new Set()
      const hitSubTechniqueIds = new Set()

      this.mitre.forEach(tactic => {
        tactic.attack_list.forEach(tech => {
          if (tech.attackid.includes('.') && tech.attackid.startsWith(parentId + '.')) {
            subTechniqueIds.add(tech.attackid)
          }
        })
      })

      Object.keys(this.sigs).forEach(subId => {
        if (subId.includes('.') && subId.startsWith(parentId + '.')) {
          hitSubTechniqueIds.add(subId)
        }
      })

      return {
        c: hitSubTechniqueIds.size,
        t: subTechniqueIds.size
      }
    },
    getHighestSeverity(id) {
      const counts = this.tagCalc(id, true)
      if (counts.error > 0) return 'error'
      if (counts.warning > 0) return 'warning'
      if (counts.blue > 0) return 'blue'
      return null
    },
    getSubTechniqueHighestSeverity(parentId) {
      const subTags = this.tagCalc(parentId, true)
      if (subTags.error > 0) return 'error'
      if (subTags.warning > 0) return 'warning'
      if (subTags.blue > 0) return 'blue'
      return null
    },
    attckClick(t) {
      if (!t || !this.sigs[t.attackid]) return
      this.mitreShow = true
      this.loading = true
      getAttackInfo({
        id: t.id,
        attackid: t.attackid,
        taskid: this.$route.params.taskId
      }).then(res => {
        this.loading = false
        this.showDetail = true
        this.attck = res
      })
    },
    tagCalc(id, includeSubTechniques = false) {
      var ret = {
        blue: 0,
        warning: 0,
        error: 0
      }

      if (this.sigs && this.sigs[id]) {
        this.sigs[id].forEach(function(ele) {
          if (ele.id === id) {
            if (ele.severity === 1) {
              ret.blue++
            } else if (ele.severity === 2) {
              ret.warning++
            } else if (ele.severity >= 3) {
              ret.error++
            }
          }
        })
      }

      if (!id.includes('.') && (includeSubTechniques || (this.sigs && this.sigs[id]))) {
        Object.keys(this.sigs).forEach((subId) => {
          if (subId.startsWith(id + '.')) {
            this.sigs[subId].forEach((ele) => {
              if (ele.severity === 1) {
                ret.blue++
              } else if (ele.severity === 2) {
                ret.warning++
              } else if (ele.severity >= 3) {
                ret.error++
              }
            })
          }
        })
      }

      return ret
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/common.scss';

.mitreAttck-wrap {
  color: var(--color-text-1);
  font-size: 14px;
  padding: 0 0 15px;
}
.mitre-table {
  border-collapse: collapse;
  min-width: 100%;
  max-height: 400px;
  overflow-y: auto;
  table-layout: fixed;
  width: fit-content;
  @include scroll_bar();
  .mitre-table-header {
    .mitre-th {
      width: 68px;
      height: 32px;
      font-size: 12px;
      color: var(--color-text-2);
      background: var(--color-bg-3);
      border: 1px solid var(--color-border-2);
      font-weight: 400;
    }
  }
  .mitre-table-row {
    .mitre-table-col {
      width: 84px;
      height: 66px;
      border: 1px solid var(--color-border-2);
      color: var(--color-text-3);
      font-size: 12px;
      vertical-align: top;
      padding: 8px;
      box-sizing: border-box;
      line-height: 16px;
      position: relative;
      word-wrap: break-word;

      &.match {
        color: var(--color-text-1);
        cursor: pointer;
        font-weight: 500;

        &.highest-error {
          &:not(.sub-technique) {
            background: var(--attck-error-bg);
          }
        }
        &.highest-warning {
          &:not(.sub-technique) {
            background: var(--attck-warn-bg);
          }
        }
        &.highest-blue {
          &:not(.sub-technique) {
            background: var(--attck-blue-bg);
          }
        }
        &.sub-highest-error {
          &.sub-technique {
            background: var(--attck-error-sub-bg);
          }
        }
        &.sub-highest-warning {
          &.sub-technique {
            background: var(--attck-warn-sub-bg);
          }
        }
        &.sub-highest-blue {
          &.sub-technique {
            background: var(--attck-blue-sub-bg);
          }
        }

        &:not(.sub-technique) {
          position: relative;
          &::before {
            content: '';
            position: absolute;
            top: -1px;
            left: -1px;
            width: 5px;
            height: calc(100% + 2px);
            background: #00ab7a;
            z-index: 1;
          }
          &.has-warning::before {
            background: #e69f32;
          }
          &.has-error::before {
            background: #ff5967;
          }
          // &.has-sub-technique {
            &::before {
              clip-path: polygon(0 0, 100% 0, 100% calc(100% - 3px), 0 100%);
            }
          // }

          .name-wrapper {
            display: inline;
          }

          .name-text {
            white-space: normal;
          }

          .sub-technique-count {
            display: inline-block;
            white-space: nowrap;
            font-size: 12px;
            vertical-align: middle;
            font-weight: 500;
          }
        }

        &.sub-technique {
          position: relative;
          &::before {
            content: '';
            position: absolute;
            top: -1px;
            left: -1px;
            width: 2px;
            height: calc(100% + 1px);
            background: #00ab7a;
            z-index: 1;
          }
          &.sub-highest-error::before {
            background: #ff5967;
          }
          &.sub-highest-warning::before {
            background: #e69f32;
          }
          &.sub-highest-blue::before {
            background: #00ab7a;
          }
          font-weight: normal;
          .tagWrapper {
            font-style: normal;
          }
        }
      }

      .tagWrapper {
        position: absolute;
        bottom: 10px;
        right: 7px;
      }
      .flag-blue, .flag-warning, .flag-error {
        display: inline-block;
        width: 14px;
        height: 14px;
        font-size: 10px;
        font-weight: normal;
        color: #fff;
        text-align: center;
        line-height: 14px;
        border-radius: 2px;
        &+[class^="flag-"] {
          margin-left: 4px;
        }
      }
      .flag-blue {
        background: #00ab7a;
      }
      .flag-warning {
        background: #e69f32;
      }
      .flag-error {
        background: #ff5967;
      }
    }
  }
}
</style>
